import ScreenUtils from '@screen';
import styled from 'styled-components';

const AnonymousModalLogin = styled.div<{ addMargin?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0
    ${({ addMargin }) => ScreenUtils.widthRatio * (addMargin ? 12 : 0)}px;
  width: fit-content;
`;

export default AnonymousModalLogin;
